import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrow = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M9.4 5.4a.849.849 0 1 1 1.2 1.2l-4.55 4.55H20a.85.85 0 0 1 .087 1.696L20 12.85H6.05l4.55 4.55a.849.849 0 1 1-1.2 1.2l-6-6a.849.849 0 0 1 0-1.2l6-6Z"
	})
});
const ForwardRef = forwardRef(SvgArrow);
export default ForwardRef;
